import OrderInfo from './order-info/index.vue';
import UserInfo from './user-info/index.vue';
import TabChange from '@/components/tab-change/index.vue';
import ReceivePayment from './receive-payment/index.vue';
import Service from '../../orders.service.js';
import ImageViewer from '@/components/image-viewer/index.vue';
import YanShou from './yanshou/index.vue';

export default {
  components: {
    OrderInfo,
    UserInfo,
    ImageViewer,
    ReceivePayment,
    TabChange,
    YanShou
  },
  data() {
    return {
      isCheck: false,
      orderDetail: {},
      dialogVisible: false,
      showDialog: false,
      showTab: 'orderInfo',
      tabArr: [{type: 'orderInfo', name: '订单详情'}]
    };
  },
  computed: {
    desc() {
      var str = ['非常差', '差', '一般', '好', '非常好'];
      if (!this.orderDetail.score) return '';
      return str[this.orderDetail.score-1];
    },
    isShowReceivePayment() {
      const status = this.orderDetail.status;
      if (this.orderDetail.payDate) {
        return true;
      }
      if (status === '030' && this.isCheck) {
        return true;
      }
      return false;
    }
  },

  created() {
    this.isCheck = this.$route.query && this.$route.query.check === 'true';
    this.getOrderDetail();
  },

  methods: {
    languageTranslate (i18n, language, key) {
      return i18n[language].hljServiceOrder[key];
    },
    changeTab(event) {
      this.showTab = event;
    },
    getOrderDetail() {
      Service.getOrderDetail(this.$route.query.id).then(res => {
        this.orderDetail = res;
        if(res.status !== '010') {
          const curTabArr = [
            {type: 'orderInfo', name: '订单详情'}
          ];
          if((res.contracts && res.contracts.length) || (res.contractedFiles && res.contractedFiles.length)) {
            curTabArr.push({type: 'contractInfo', name: '合同信息'});
          }
          if(res.executeRecords && res.executeRecords.length) {
            curTabArr.push({type: 'workList', name: '作业记录'});
          }
          this.tabArr = curTabArr;
        }
      });
    },
    printAction () {
      var head_str = '<html><head><title></title></head><body>'; // 先生成头部
      var foot_str = '</body></html>'; // 生成尾部
      var older = document.body.innerHTML;
      var new_str = document.getElementById('print').innerHTML; // 获取指定打印区域
      document.body.innerHTML = head_str + new_str + foot_str; // 构建新网页
      window.print(); // 打印刚才新建的网页
      document.body.innerHTML = older; // 将网页还原
    },
    back() {
      this.$router.back();
    },
    allPrice(items) {
      const price = (items || []).map(item => item.price);
      const num = price.length && (price.reduce((prev, cur) => (prev * 100 + cur * 100)/100) || 0);
      return Number(num).toFixed(2);
    },
    subsidy(items) {
      const price = (items || []).map(item => item.subsidy);
      const num = price.length && (price.reduce((prev, cur) => (prev * 100 + cur * 100)/100) || 0);
      return Number(num).toFixed(2);
    },
    refreshWorkList() {
      this.getOrderDetail();
    }
  }
};
